// @flow

import React from 'react';
import { Chart } from 'react-google-charts';
import { AutocompleteByWeek } from 'UI/components/atoms/AutocompleteByWeek';

import { DEFAULT_OPTIONS } from './WeeklyMetricTrend.constants';

interface WeeklyMetricTrendProps {
  data: (string | number | object)[][];
  onSelectWeek?: (week: object) => void;
  options?: object;
}

export const WeeklyMetricTrend = ({ data, onSelectWeek, options }: WeeklyMetricTrendProps) => {
  return (
    <>
      <AutocompleteByWeek onSelectWeek={onSelectWeek} />

      <Chart
        chartType="LineChart"
        data={data}
        data-testid="lineChart"
        height="400px"
        legendToggle
        options={{ ...DEFAULT_OPTIONS, ...options }}
        width="100%"
      />
    </>
  );
};
